import React from 'react';
import AppHeader from './AppHeader';
import ProjectsSidebar from './ProjectsSidebar';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const ProjectsLayout = () => {
  const sidebarWidth = 64;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header fixed at top */}
      <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200 }}>
        <AppHeader />
      </Box>

      {/* Sidebar */}
      <ProjectsSidebar />

      {/* Main content area starts below header with left margin for sidebar */}
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: '#f3f2f5ff',
          minHeight: 'calc(100vh - 64px)',
          mt: '64px',
          ml: `${sidebarWidth}px`,
          p: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default ProjectsLayout;
